import * as React from "react";
import { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Avatar from "@mui/material/Avatar";
import { useForm } from "react-hook-form";
import { Row, Col, Card, Button } from "react-bootstrap";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import { Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { CreatePartnerUser } from "../../API/endpoints/Partner";
import { GetRolesByType } from "../../API/endpoints/RolesAndPermissions/Roles";
import { GetCountryCodes } from "../../API/endpoints/Common";
import { getUserByPartner } from "../../API/endpoints/User";
import { GetUserProfile } from "../../API/endpoints/User";
import ToastMessage from "../components/toasts/ToastMessage";
import {
  UpdatePartnerUser,
  DeletePartnerUser,
} from "../../API/endpoints/Partner";
import "./PartnerTeamNew.scss";
import ConfirmModal from "../components/Modal/ConfirmModal";

export default function AlertDialog(props: {
  partnerData: any;
  disableEdit?: boolean | false;
  disableAdd?: boolean | true;
}) {
  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState({ type: "", msg: "" });
  const [countryCodes, setCountryCodes] = useState<any[]>([]);
  const [roles, setRoles] = useState<any[]>([]);
  const [partnerTeam, setPartnerTeam] = useState<any[]>([]);
  const [partnerUserId, setPartnerUserId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      designation: "",
      email: "",
      phone: "",
      code: "",
      role: [],
    },
  });

  const handleCloseNotification = () =>
    setNotification({
      type: "",
      msg: "",
    });

  const handleClickOpen = () => {
    setIsEdit(false);
    setOpen(true);
  };

  const handleClose = () => {
    let defaults: any = {
      firstName: "",
      lastName: "",
      designation: "",
      email: "",
      contact_number_code: "",
      phone: "",
      role: [],
    };
    reset(defaults);
    setOpen(false);
  };
  function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  function stringAvatar(name: string) {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
    };
  }

  const deleteTeamPartnerHandler = async () => {
    (async () => {
      try {
        await DeletePartnerUser(openConfirmDeleteModal);
        setOpenConfirmDeleteModal("");
        setNotification({
          type: "success",
          msg: "Team Member successfully deleted.",
        });
        fetchTeamPartnerHandler();
      } catch (ex: any) {
        // validate(ex);
        setNotification({
          type: "error",
          msg: "Failed to delete team member.",
        });
        setOpenConfirmDeleteModal("");
      }
    })();
  };

  const editTeamPartnerHandler = async (memberId: any) => {
    setPartnerUserId(memberId);
    // ----------------------------------------
    (async () => {
      let userProfile = await GetUserProfile(memberId);
      let defaults: any = {
        firstName: userProfile.data?.first_name,
        lastName: userProfile.data?.last_name,
        designation: userProfile.data?.designation,
        email: userProfile.data?.email_id,
        contact_number_code: userProfile.data?.contact_number_code,
        phone: userProfile.data?.contact_number,
        role: userProfile.data?.user_roles[0]?.roles?.id,
      };
      reset(defaults);
    })();
    // ----------------------------------------
    setIsEdit(true);
    setOpen(true);
  };

  const validateEmail = (email: string) => {
    const regx =
      /^([a-zA-Z0-9.-]+)@([a-zA-Z0-9-]+).([a-z]{2,8})(.[a-z]{2,8})?$/;
    if (regx.test(email)) {
      return true;
    } else {
      setError("email", {
        type: "custom",
        message: "Please Enter Valid Email Address",
      });
      return false;
    }
  };

  // ----------------------------------------------------------------
  const handleSubmitForm = async (data: {
    firstName: string;
    lastName: string;
    designation: string;
    email: string;
    phone: string;
    code: string;
  }) => {
    const numberOnly = /^\d+$/;
    const specialCharactersOnly = /^[^\w\s]+$/;
    if (numberOnly.test(data.firstName)) {
      setError("firstName", {
        type: "custom",
        message: "Only numbers not are valid",
      });
      return false;
    } else if (specialCharactersOnly.test(data.firstName)) {
      setError("firstName", {
        type: "custom",
        message: "Only special characters are not valid",
      });
      return false;
    }

    if (numberOnly.test(data.lastName)) {
      setError("lastName", {
        type: "custom",
        message: "Only numbers not are valid",
      });
      return false;
    } else if (specialCharactersOnly.test(data.lastName)) {
      setError("lastName", {
        type: "custom",
        message: "Only special characters are not valid",
      });
      return false;
    }

    if (numberOnly.test(data.designation)) {
      setError("designation", {
        type: "custom",
        message: "Only numbers not are valid",
      });
      return false;
    } else if (specialCharactersOnly.test(data.designation)) {
      setError("designation", {
        type: "custom",
        message: "Only special characters are not valid",
      });
      return false;
    }

    if (!numberOnly.test(data.phone)) {
      setError("phone", {
        type: "custom",
        message: "Accepts numbers only",
      });
      return false;
    } else if (data.phone.length > 12) {
      setError("phone", {
        type: "custom",
        message: "Maximum 12 digits",
      });
      return false;
    }

    let teamMember: any = {
      first_name: data.firstName,
      last_name: data.lastName,
      designation: data.designation,
      email_id: data.email,
      contact_number: data.phone,
      contact_number_code: data.code,
      user_type: "partner",
      partner_id: props.partnerData?.id,
      role: [roles[1].id],
    };
    const validEmail = validateEmail(teamMember.email_id);
    if (!validEmail) return;
    if (isEdit) {
      const newTeamMember = { ...teamMember, region: [2], department: 1 };
      (async () => {
        try {
          await UpdatePartnerUser(partnerUserId, newTeamMember);
          setNotification({
            type: "success",
            msg: "Team Member successfully updated.",
          });
          handleClose();
          fetchTeamPartnerHandler();
        } catch (ex: any) {
          // validate(ex);
          setNotification({
            type: "error",
            msg: "Failed to update team member.",
          });
        }
      })();
    } else {
      (async () => {
        try {
          await CreatePartnerUser(teamMember);
          setNotification({
            type: "success",
            msg: "Team Member successfully Added.",
          });
          handleClose();
          fetchTeamPartnerHandler();
        } catch (err) {
          console.error(err);
          setNotification({ type: "error", msg: err as string });
        }
      })();
    }
  };
  // ----------------------------------------------------------------

  const fetchTeamPartnerHandler = () => {
    (async () => {
      const res = await getUserByPartner(props.partnerData?.id);
      setPartnerTeam(res.data.rows);
      setIsEdit(false);
    })();
  };

  useEffect(() => {
    (async () => {
      setCountryCodes([]);
      const res = await GetCountryCodes();
      setCountryCodes(res.data);
    })();
    (async () => {
      setRoles([]);
      const res = await GetRolesByType("partner");
      setRoles(res.data);
    })();
  }, []);

  useEffect(() => {
    fetchTeamPartnerHandler();
  }, [props.partnerData?.id]);

  return (
    <React.Fragment>
      <Card
        style={{
          marginTop: "9px",
          padding: "10px 16px",
          verticalAlign: "center",
          borderRadius: "2px",
          background: "#FFF",
          borderColor: "white",
          boxShadow:
            "0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)",
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Stack
            sx={{
              color: "#1D2939",
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "20px",
            }}
          >
            Partner Team
          </Stack>
          {props?.disableAdd ? (
            <></>
          ) : (
            <Button
              onClick={handleClickOpen}
              style={{
                maxWidth: "20px",
                padding: "0",
                maxHeight: "20px",
                textAlign: "center",
                lineHeight: "20px",
              }}
              // onClick={handleClickl}
              className="badgepill-blue50  blue-text br-0 bold no-border align-center"
            >
              <AddIcon
                sx={{
                  fontSize: "19px",
                  fontWeight: "500",
                  alignItems: "center",
                }}
              />
            </Button>
          )}
        </Grid>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingTop: "10px",
          }}
        >
          {partnerTeam && partnerTeam.length > 0 ? (
            partnerTeam.map((item) => (
              <div
                key={item.id}
                style={{
                  display: "flex",
                  padding: "8px 4px",
                }}
              >
                <div className="d-flex align-center">
                  <Avatar
                    style={{
                      marginRight: "8px",
                      width: "24px",
                      height: "24px",
                      backgroundColor: "#EFF8FF",
                      color: "#0152FB",
                      fontSize: "8px",
                      fontWeight: 500,
                      alignItems: "center",
                    }}
                    {...stringAvatar(
                      `${item.first_name + " " + item?.last_name}`
                    )}
                  />
                  <Typography sx={{ fontSize: "13px", fontWeight: 400 }}>
                    {item.first_name + " " + (item?.last_name || "")}
                  </Typography>
                </div>
                {props?.disableEdit || props?.disableAdd ? (
                  <></>
                ) : (
                  <div className="ml-auto d-flex">
                    <Button
                      style={{
                        background: "white",
                        width: "20px",
                        padding: "0",
                        maxHeight: "20px",
                        textAlign: "center",
                        lineHeight: "20px",
                      }}
                      onClick={() => {
                        editTeamPartnerHandler(item.id);
                      }}
                      className="br-0 bold no-border align-center"
                    >
                      <img
                        width="20px"
                        className="mr8px"
                        src="../svgs/edit.svg"
                        alt="edit"
                      />
                    </Button>
                    <Button
                      style={{
                        background: "white",
                        marginLeft: "10px",
                        width: "20px",
                        padding: "0",
                        maxHeight: "20px",
                        textAlign: "center",
                        lineHeight: "20px",
                      }}
                      onClick={() => {
                        setOpenConfirmDeleteModal(item.id);
                      }}
                      className="br-0 bold no-border align-center"
                    >
                      <img
                        width="20px"
                        className="mr8px"
                        src="../svgs/delete.svg"
                        alt="delete"
                      />
                    </Button>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div
              style={{
                paddingRight: "0px",
                backgroundColor: "white",
                height: "5rem",
                width: "100%",
                marginTop: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "500",
                  borderRadius: "2px",
                  color: "#black",
                  fontSize: "12px",
                  padding: "4px",
                }}
              >
                No data found
              </Typography>
            </div>
          )}
        </div>
      </Card>
      <Dialog
        className="modal_700"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`${
          isEdit == false ? "Add team member" : "Edit team member"
        }`}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Form
            id="addPartnerForm"
            onSubmit={handleSubmit((data) => {
              handleSubmitForm(data);
            })}
          >
            <Row className="mb16px">
              <Col sm={6} md={6} lg={6}>
                <Form.Group className="mb-1" controlId="fullname">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter First Name"
                    {...register("firstName", {
                      required: "* This field is required",
                    })}
                  />
                  <Form.Text muted>
                    <span>
                      <p className="error-form">{errors.firstName?.message}</p>
                    </span>
                  </Form.Text>
                </Form.Group>
              </Col>
              <Col sm={6} md={6} lg={6}>
                <Form.Group className="mb-1" controlId="fullname">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Last Name"
                    {...register("lastName", {
                      required: "* This field is required",
                    })}
                  />
                  <Form.Text muted>
                    <span>
                      <p className="error-form">{errors.lastName?.message}</p>
                    </span>
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb16px">
              <Col>
                <Form.Group className="mb-1" controlId="fullname">
                  <Form.Label>Designation</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter designation"
                    {...register("designation", {
                      required: "* This field is required",
                    })}
                  />
                  <Form.Text muted>
                    <span>
                      <p className="error-form">
                        {errors.designation?.message}
                      </p>
                    </span>
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb16px">
              <Col sm={6} md={6} lg={6}>
                <div className="input-email mb24px">
                  <Form.Label>Email</Form.Label>
                  <InputGroup>
                    <InputGroup.Text id="basic-addon1">
                      <img src="../svgs/mail.svg" alt="mail" />
                    </InputGroup.Text>
                    <Form.Control
                      placeholder="sample@mail.com"
                      type="email"
                      {...register("email", {
                        required: "* This field is required",
                      })}
                    />
                  </InputGroup>
                  <Form.Text muted>
                    <span>
                      <p className="error-form">{errors.email?.message}</p>
                    </span>
                  </Form.Text>
                </div>
              </Col>
              <Col sm={6} md={6} lg={6}>
                <Form.Group className="formgroup mb-1" controlId="phone">
                  <Form.Label>Phone</Form.Label>
                  <InputGroup>
                    <Form.Select
                      {...register("code")}
                      aria-label="20"
                      className="countrycode"
                      key={"country" + Math.floor(Math.random() * 100)}
                    >
                      {countryCodes[0] &&
                        countryCodes
                          ?.filter((code) => {
                            return code.country_code !== "";
                          })
                          .map((code) => {
                            return (
                              <option
                                key={Math.random()}
                                value={code.country_code}
                              >
                                {code.country_code}
                              </option>
                            );
                          })}
                    </Form.Select>
                    <Form.Control
                      type="text"
                      placeholder="Enter Phone number"
                      {...register("phone", {
                        required: "* This field is required",
                      })}
                    />
                  </InputGroup>
                  <Form.Text muted>
                    <span>
                      <p className="error-form">{errors.phone?.message}</p>
                    </span>
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </DialogContent>
        <DialogActions>
          <Button variant="outline" onClick={handleClose}>
            Cancel
          </Button>
          <Button type="submit" form="addPartnerForm" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <ToastMessage
        notification={notification}
        onCancel={handleCloseNotification}
      />

      <ConfirmModal
        haveIcon={false}
        isModalOpen={Boolean(openConfirmDeleteModal)}
        submit={deleteTeamPartnerHandler}
        closeModal={() => setOpenConfirmDeleteModal("")}
        submitBtnText="Confirm"
        cancelBtnText="Cancel"
        title="Confirm Delete Partner Team Member"
        bodyText="Are you sure you want to delete this team member?"
      />
    </React.Fragment>
  );
}
